import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { APP_CONFIG } from '@frontend/app-config';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  ApiUrl!: string;
  getCountriesData: any;

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) private appConfig: any
  ) {
    this.ApiUrl = `${this.appConfig.apiUrl}`;
  }

  register(user: any) {
    let Api;

    if (user.email) {
      Api = 'account/signup/email';
    } else {
      Api = 'account/signup/phone';
    }

    return this.http.post(`${this.ApiUrl}${Api}`, user, {
      headers: new HttpHeaders({
        'Skip-auth': 'true',
        'x-km-api-version': '2.0',
        'x-km-app-build-name': 'com.music.app',
        'x-km-app-build-version': '1.0.0',
        'x-km-app-lang': 'en',
        'x-km-app-os': 'web',
        'x-km-device-id': this.getOrCreateDeviceId(),
      }),
    });
  }

  private getOrCreateDeviceId(): string {
    const key = '[KWOT]-deviceId';
    try {
      let deviceId = localStorage.getItem(key);
      if (!deviceId) {
        deviceId = 'web-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
        localStorage.setItem(key, deviceId);
      }
      return deviceId;
    } catch {
      return 'web-unknown';
    }
  }

  validateOtp(otp: any) {
    let url = '';
    const headers = new HttpHeaders().set('Skip-auth', 'true');

    url = 'account/signup/phone/verify';
    return this.http.post(`${this.ApiUrl}/${url}`, otp, {
      headers: headers,
    });
  }

  login(user: any) {
    let Api;

    if (user.email) {
      if (user.provider) {
        Api = 'account/socialLogin'
      } else {
        Api = 'account/signin/email';
      }
    } else {
      Api = 'account/signin/phone';
    }
    return this.http.post(`${this.ApiUrl}${Api}`, user, {
      headers: new HttpHeaders().set('Skip-auth', 'true'),
    });
  }

  verifyOtp(email: string, otp: string) {
    let url = '';
    const headers = new HttpHeaders().set('Skip-auth', 'true');

    url = 'account/admin/verification';
    return this.http.post(`${this.ApiUrl}/${url}`, { email, otp }, {
      headers: headers
    })
  }


  verifyEmail(email: string) {
    let url = '';
    const headers = new HttpHeaders().set('Skip-auth', 'true');
    console.log(`this.url ${this.ApiUrl}` );

    url = 'users/verify/email';
    console.log(`this.url ${this.ApiUrl}${url}` );
    return this.http.post(`${this.ApiUrl}${url}`, { email }, {
      headers: headers
    })
  }

  sendDeleteOtp(email: string, reason: string) {
    let url = '';
    const headers = new HttpHeaders().set('Skip-auth', 'true');
    console.log(`this.url ${this.ApiUrl}` );

    url = 'users/sent-otp';
    console.log(`this.url ${this.ApiUrl}${url}` );
    return this.http.post(`${this.ApiUrl}${url}`, { email, reason }, {
      headers: headers
    })
  }

  verifyDeleteOTP(email: string, otp: string, reason: string) {
    let url = '';
    const headers = new HttpHeaders().set('Skip-auth', 'true');
    console.log(`this.url ${this.ApiUrl}` );

    url = 'users/verify-otp';
    console.log(`this.url ${this.ApiUrl}${url}` );
    return this.http.post(`${this.ApiUrl}${url}`, { email, otp, reason }, {
      headers: headers
    })
  }

  resendOtp(email: string) {
    let url = '';
    const headers = new HttpHeaders().set('Skip-auth', 'true');

    url = 'account/admin/verification/resend';
    return this.http.post(`${this.ApiUrl}/${url}`, { email }, {
      headers: headers
    })
  }

  sendOtp(phone_number: string, country_code: string) {
    return this.http.post(
      `${this.ApiUrl}/account/signup/phone/otp`,
      {
        phone_number: phone_number.toString(),
        country_code: country_code.toString(),
      },
      {
        headers: new HttpHeaders().set('Skip-auth', 'true'),
      }
    );
  }

  forgotPassword(user: any) {
    let Api;
    if (user.email) {
      Api = 'account/recovery/email';
    } else {
      Api = 'account/recovery/phone';
    }
    return this.http.post(`${this.ApiUrl}${Api}`, user, {
      headers: new HttpHeaders().set('Skip-auth', 'true'),
    });
  }

  resetPassword(passwordBody: any) {
    let url = '';
    let headers = new HttpHeaders().set('Skip-auth', 'true');
    if (passwordBody.id) {
      url = `account/reset-password-by-reset-link`;
    } else {
      url = 'account/recovery/set-password';
      headers = headers.append('AddTempAuth', 'true');
    }
    return this.http.put(
      `${this.ApiUrl}${url}`,
      { ...passwordBody },
      { headers }
    );
  }

  checkAccountVerifyLink(token: string) {
    return this.http.get(
      `${this.ApiUrl}/account/profile/add-email/verify/${token}`,
      {
        headers: new HttpHeaders().set('Skip-auth', 'true'),
      }
    );
  }

  verifyData(params: any) {
    return this.http.post(
      `${this.ApiUrl}account/sendProfileVerification`,
      params,
      {
        headers: new HttpHeaders().set('Skip-auth', 'true'),
      }
    );
  }

  getCountryId() {
    return this.http.get(`${this.ApiUrl}/miscellaneous/countries`, {
      headers: new HttpHeaders().set('Skip-auth', 'true'),
    });
  }

  getProvincesByCountry(countryId: string) {
    return this.http.get(
      `${this.ApiUrl}/miscellaneous/countries/${countryId}/provinces`,
      {
        headers: new HttpHeaders().set('Skip-auth', 'true'),
      }
    );
  }

  getPrivacy() {
    return this.http.get(`${this.ApiUrl}policy`, {
      headers: new HttpHeaders().set('Skip-auth', 'true'),
    });
  }

  contactUs(user: any) {
    return this.http.post(`${this.ApiUrl}contact`, user, {
      // headers: new HttpHeaders().set('Skip-auth', 'true'),
    });
  }

  getFiltersOptionData(params: any = {}) {
    return this.http.get(`${this.ApiUrl}/music/filters-option`, { params });
  }

  getMiscellaneousCountries(params: any = {}) {
    return this.http.get(`${this.ApiUrl}/miscellaneous/countries`, { params });
  }

  getMiscellaneousProvinces(id: string) {
    return this.http.get(
      `${this.ApiUrl}/miscellaneous/countries/${id}/provinces`
    );
  }

  loginWithToken(token: string) {
    return this.http.post(`${this.ApiUrl}/account/login-with-token`, { token });
  }

  autoLogin(token: string) {
    return this.http.get(`${this.ApiUrl}account/auto-login`, {
      params: { token },
      headers: new HttpHeaders().set('Skip-auth', 'true'),
    });
  }
}
